import { render, staticRenderFns } from "./unionApplyList.vue?vue&type=template&id=2b44e762&scoped=true&"
import script from "./unionApplyList.vue?vue&type=script&lang=js&"
export * from "./unionApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b44e762",
  null
  
)

export default component.exports